module.exports = "@media (min-width: 900px) and (min-height: 450px) {\n  .raspberry {\n    display: none;\n  }\n}\n"